import React, { useEffect, useState } from "react";
import { AiFillBackward } from "react-icons/ai";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { useGetSuppliersQuery } from "../../features/api/supplierApi";
import { useGetCategoryQuery } from "../../features/api/categoryApi";
import { API_BASE_URL } from "../../components/baseUrl";
const UpdatePurchase = () => {
  const location = useLocation();
  const { row, suppName, proName } = location?.state;
  // const row = location?.state;

  // date format
  function formatDate(dateString) {
    const date = new Date(dateString);
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let getDate = day + "-" + month + "-" + year;
    return getDate;
  }

  const { data, error, isLoading } = useGetSuppliersQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const suppliers = data?.supplier;

  const { data: category } = useGetCategoryQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const categories = data?.categories;

  const [ch_date, setChDate] = useState("");
  const [supp_name, setSuppName] = useState("");
  const [cat_name, setCategory] = useState("");
  const [sub_catName, setSubCategory] = useState("");
  const [pro_name, setProduct] = useState("");
  const [qty, setQuantity] = useState("");
  const [unit_price, setPrice] = useState("");

  const total =
    qty * unit_price ||
    qty * row?.unit_price ||
    row?.qty * unit_price ||
    row?.total;

  // fetch sub-category by category name
  const [subCatByCat, setSubCatByCat] = useState([]);
  const [relode, setRelode] = useState(false);
  useEffect(() => {
    fetch(`${API_BASE_URL}/api/sub-categories/${cat_name}`)
      .then((res) => res.json())
      .then((data) => {
        setSubCatByCat(data?.subCategory);
        setRelode(!relode);
      });
  }, [cat_name]);

  // fetch product by sub-category name
  const [getProductBySubCat, setGetProductBySubCat] = useState([]);
  useEffect(() => {
    fetch(
      `${API_BASE_URL}/api/subCatProducts?subCategory=${sub_catName}`
    )
      .then((res) => res.json())
      .then((data) => {
        setGetProductBySubCat(data?.product);
        setRelode(!relode);
      });
  }, [sub_catName]);

  const navigate = useNavigate();
  // handle function for purchase product
  const handleUpdate = async (id) => {
    try {
      const data = {
        ch_date: ch_date ? ch_date : row?.ch_date,
        supp_name: supp_name ? supp_name : row?.supp_name,
        sub_category: sub_catName ? sub_catName : row?.sub_category,
        pro_name: pro_name ? pro_name : row?.pro_name,
        qty: qty ? qty : row?.qty,
        unit_price: unit_price ? unit_price : row?.unit_price,
        total: total ? total : row?.total,
      };
      const response = await axios.patch(
        `${API_BASE_URL}/api/purchases/${id}`,
        data
      );
      if (response) {
        navigate("/dashboard/purchase");
      }
    } catch (error) {
      console.error("Error updating data:", error?.response);
    }
  };
  return (
    <div className=" overflow-auto">
      <div className="flex justify-between items-center p-4">
        <h1 className="text-xl font-bold">Update Purchase {pro_name}</h1>
        <Link
          to="/dashboard/purchase"
          className="bg-blue-500 px-2 py-1 rounded font-bold text-white flex items-center gap-x-1"
        >
          <AiFillBackward /> Purchase List{" "}
        </Link>
      </div>
      <div>
        <div className="p-4 m-4 border">
          <form className=" grid grid-cols-2 lg:grid-cols-3  gap-6">
            <div className="flex flex-col gap-1">
              <label>Chalan No.</label>
              <input
                type="text"
                value={row?.ch_no}
                disabled
                className="border h-8 pl-1"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label>Chalan Date</label>
              <div>
                <input
                  type="text"
                  defaultValue={formatDate(row?.ch_date)}
                  className="border h-8 pl-1 w-[50%]"
                />
                <input
                  onChange={(e) => setChDate(e.target.value)}
                  type="date"
                  defaultValue={row?.ch_date}
                  className="border h-8 pl-1 w-[50%]"
                />
              </div>
            </div>
            <div className="flex flex-col gap-1">
              <label>Supplier Name</label>
              <select
                onChange={(e) => setSuppName(e.target.value)}
                className="border h-8 pl-1"
              >
                <option>{suppName?.s_name}</option>
                {suppliers?.map((supplier) => (
                  <option key={supplier?.id}>{supplier?.s_name}</option>
                ))}
              </select>
            </div>
            <div className="flex flex-col gap-1">
              <label>Category</label>
              <select
                onChange={(e) => setCategory(e.target.value)}
                className="border h-8 pl-1"
              >
                <option>--select--</option>
                {categories?.map((category) => (
                  <option key={category?.id} value={category?.id}>
                    {category?.cat_name}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex flex-col gap-1">
              <label>Sub_Category</label>
              <select
                onChange={(e) => setSubCategory(e.target.value)}
                className="border h-8 pl-1"
              >
                <option>--select--</option>
                {subCatByCat?.map((sCat) => (
                  <option key={sCat?.id} value={sCat?.id}>
                    {sCat?.sub_catName}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex flex-col gap-1">
              <label>Product</label>
              <select
                onChange={(e) => setProduct(e.target.value)}
                className="border h-8 pl-1"
              >
                <option>{proName?.product_name}</option>
                {getProductBySubCat?.map((product) => (
                  <option key={product?.id}>{product?.product_name}</option>
                ))}
              </select>
            </div>
            <div className="flex flex-col gap-1">
              <label>Quantity</label>
              <input
                onChange={(e) => setQuantity(e.target.value)}
                type="number"
                defaultValue={row?.qty}
                className="border h-8 pl-1"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label>Price</label>
              <input
                onChange={(e) => setPrice(e.target.value)}
                type="number"
                defaultValue={row?.unit_price}
                className="border h-8 pl-1"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label>Total</label>
              <input type="text" value={total} className="border h-8 pl-1" />
            </div>
          </form>
          <button
            onClick={() => handleUpdate(row?.id)}
            className="bg-green-600 px-4 py-1 text-white font-bold block mx-auto mt-4"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdatePurchase;
